import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateCustomFieldValueMutation($input: UpdateCustomFieldValueInput!) {
		updateCustomFieldValue(input: $input) {
			customFieldValue {
				node {
					id
					key
					displayName
					value
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.entityId,
			edgeName: 'customFieldValue',
			connectionInfo: [
				{
					key: 'TimeRegistrations_customFields',
					rangeBehavior: 'append',
				},
			],
		},
	];
}

function getOptimisticResponse(input) {
	return {
		updateCustomFieldValue: {
			customFieldValue: {
				node: {
					__typename: input.__typename,
					id: input.id,
					key: input.key,
					value: input.value,
					displayName: undefined,
				},
			},
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('CustomFieldValue - Updated');
	const optimisticResponse = getOptimisticResponse(input);
	delete input.__typename;

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		optimisticResponse,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
